const BCPCrisis = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.3628 5.707C21.8762 9.2215 21.8762 14.9185 18.3628 18.433C17.9723 18.8236 17.9724 19.4567 18.363 19.8472C18.7536 20.2377 19.3867 20.2376 19.7772 19.847C24.0714 15.5515 24.0714 8.5885 19.7772 4.293C19.3867 3.90242 18.7536 3.90232 18.363 4.29279C17.9724 4.68325 17.9723 5.31642 18.3628 5.707ZM10.3753 4.28913L5.64922 8.07H2C1.44772 8.07 1 8.51772 1 9.07V15.07C1 15.6223 1.44772 16.07 2 16.07H5.64922L10.3753 19.8509C11.0301 20.3747 12 19.9085 12 19.07V5.07C12 4.23149 11.0301 3.76532 10.3753 4.28913ZM6.62469 9.85087L10 7.15062V16.9894L6.62469 14.2891C6.44738 14.1473 6.22707 14.07 6 14.07H3V10.07H6C6.22707 10.07 6.44738 9.99272 6.62469 9.85087ZM14.8328 14.893C16.3943 13.331 16.3943 10.799 14.8328 9.237C14.4423 8.84642 14.4424 8.21325 14.833 7.82279C15.2236 7.43232 15.8567 7.43242 16.2472 7.823C18.5895 10.166 18.5895 13.964 16.2472 16.307C15.8567 16.6976 15.2236 16.6977 14.833 16.3072C14.4424 15.9167 14.4423 15.2836 14.8328 14.893Z"
        fill="#437EF7"
      />
      <mask
        id="mask0_3642_18994"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="4"
        width="22"
        height="17"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.3628 5.707C21.8762 9.2215 21.8762 14.9185 18.3628 18.433C17.9723 18.8236 17.9724 19.4567 18.363 19.8472C18.7536 20.2377 19.3867 20.2376 19.7772 19.847C24.0714 15.5515 24.0714 8.5885 19.7772 4.293C19.3867 3.90242 18.7536 3.90232 18.363 4.29279C17.9724 4.68325 17.9723 5.31642 18.3628 5.707ZM10.3753 4.28913L5.64922 8.07H2C1.44772 8.07 1 8.51772 1 9.07V15.07C1 15.6223 1.44772 16.07 2 16.07H5.64922L10.3753 19.8509C11.0301 20.3747 12 19.9085 12 19.07V5.07C12 4.23149 11.0301 3.76532 10.3753 4.28913ZM6.62469 9.85087L10 7.15062V16.9894L6.62469 14.2891C6.44738 14.1473 6.22707 14.07 6 14.07H3V10.07H6C6.22707 10.07 6.44738 9.99272 6.62469 9.85087ZM14.8328 14.893C16.3943 13.331 16.3943 10.799 14.8328 9.237C14.4423 8.84642 14.4424 8.21325 14.833 7.82279C15.2236 7.43232 15.8567 7.43242 16.2472 7.823C18.5895 10.166 18.5895 13.964 16.2472 16.307C15.8567 16.6976 15.2236 16.6977 14.833 16.3072C14.4424 15.9167 14.4423 15.2836 14.8328 14.893Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3642_18994)">
        <rect width="24" height="24" fill="#437EF7" />
      </g>
    </svg>
  );
};

export default BCPCrisis;
